import { render, staticRenderFns } from "./anonymous_vote.vue?vue&type=template&id=4568a78c&scoped=true&"
import script from "./anonymous_vote.vue?vue&type=script&lang=js&"
export * from "./anonymous_vote.vue?vue&type=script&lang=js&"
import style0 from "./anonymous_vote.vue?vue&type=style&index=0&id=4568a78c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4568a78c",
  null
  
)

export default component.exports